import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
};

const createRecruitmentSlice = createSlice({
  name: "createRecruitment",
  initialState,
  reducers: {
    createRecruitmentStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    createRecruitmentSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    createRecruitmentFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  createRecruitmentStart,
  createRecruitmentSuccess,
  createRecruitmentFailed,
} = createRecruitmentSlice.actions;

export default createRecruitmentSlice.reducer;
